import type { HTMLAttributes } from 'react'
import cx from 'classnames'

type PageContainerProps = HTMLAttributes<HTMLDivElement>

export function PageContainer({ className, children, ...rest }: PageContainerProps): JSX.Element {
  return (
    <div
      className={cx(
        'bg-white rounded-[26px] shadow-[0px_18px_45px_rgba(15,23,42,0.08)] p-8',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
